import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import SearchVisitorsReportCard from "../../../components/card/SearchVisitorsReportCard";
import VisitorsReportTable from "../../../components/table/VisitorsReportTable";
import { ExportVisitorsReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const VisitorsReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportVisitorsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allRequests, setAllRequests] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("visitorsReport")}
        </h1>
      </BackButtonWrapper>

      <SearchVisitorsReportCard
        setAllRequests={setAllRequests}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <VisitorsReportTable
        exportBody={exportBody}
        allRequests={allRequests}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default VisitorsReport;
